import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleEllipsis } from '@fortawesome/pro-regular-svg-icons';
import { faChevronLeft, faUsers } from '@fortawesome/pro-solid-svg-icons';
import Dropdown from '@mysidewalk/react-dropdown';

import '../../../src/styles/variables.css';
import './Breadcrumbs.css';

export type Props = {
  back: {
    label: string,
    url: string,
    onClick: () => void,
  },
  content: {
    label: string,
    sharedURL?: string,
    menu: {
      label: string,
      onClick?: () => void,
      href?: string,
    }[];
  },
};

function Breadcrumbs({
  back,
  content,
}: Props) {
  if (!back) return null;
  return (
    <div
      id="global-nav-breadcrumbs"
      data-test-id="header.breadcrumbs"
      className="Breadcrumbs"
    >
      <div className="Breadcrumb-Back">
        <a
          href={back.url}
          onClick={back.onClick}
          className="Breadcrumb-BackLink"
          data-test-id="header.breadcrumbs.links.back"
        >
          <FontAwesomeIcon
            className="fa-sm fa-fw"
            icon={faChevronLeft}
          />
          {back.label}
        </a>
      </div>
      <div className="Breadcrumb-Content">
        <div>
          {content.sharedURL && (
            <a
              href={content.sharedURL}
              target="_blank"
              rel="noopener"
              className="Breadcrumb-ContentSharedLink"
              title="Open shared version"
            >
              <span className="breadcrumb-title-icon">
                <FontAwesomeIcon icon={faUsers} className="fa-fw fa-sm" />
              </span>
            </a>
          )}
          <span className="Breadcrumb-ContentLabel">{content.label}</span>
        </div>
        {content.menu && (
          <Dropdown
            id="global-nav-breadcrumb-menu"
            variant="dark"
          >
            <Dropdown.Toggle
              caret={false}
              data-test-id="header.breadcrumbs.menu.toggle"
              className="Breadcrumb-ContentMenuToggle"
            >
              <FontAwesomeIcon
                icon={faCircleEllipsis}
                className="fa-fw fa-sm"
              />
              <span className="sr-only">More options</span>
            </Dropdown.Toggle>
            <Dropdown.Menu 
              align="right"
              width="sm"
            >
              {content.menu.map((item) => (
                <Dropdown.Item
                  key={item.label}
                  onClick={item.onClick}
                  href={item.href}
                  as={item.href ? 'a' : 'button'}
                >
                  {item.label}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        )}
      </div>
    </div>
  );
}

Breadcrumbs.displayName = 'Breadcrumbs';

export default Breadcrumbs;
